import React, { Component } from 'react';
import NavTab from '../components/common/global_layout/navTab'
import '../style/css/global_layout/home.css'
import AdvencedSearchGhurfaty from '../components/common/Hebergement/advencedSearchGhurfaty';
import AdvancedSearchVols from '../components/common/Vols/advancedSearchVols';
import AdvencedSearchVisas from '../components/common/Visas/advancedSearchVisas1';
import AdvancedSearchVoyage from '../components/common/Voyages/advancedSearchVoyage';
import {
  Container,
  Col,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  FormGroup,
  Label,
  Input,
  DropdownItem,
  Form,
  NavLink,
  Button
} from "reactstrap";
import { Image } from "semantic-ui-react";
import AdvencedSearchVisa from './patricular/Visa/Advanced_searchVisa';
import AdvancedSearchLocation from '../components/common/Cars/advancedSearchLocation';
import advancedSearchVisas from '../components/common/Visas/advancedSearchVisas';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Footer from '../components/common/global_layout/footer';
import Decvrcard from '../components/common/home/decvrCard';
import Temoincard from '../components/common/home/temoinCard';
import HeadMobile from '../components/common/global_layout/carouselMobile';
import NavTabMobile from '../components/common/global_layout/navtabMobile';


class Home extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      catego: "Hébergements",
      loading: false,
      data: [],
      headline: []
    };
  }


  // getCurrentcatego() {
  //   //  get current page through the route
  //   const subDirectories = ["Hébergements", "Vols", "Visas", "Voyages", "Véhicules", "divertissements"]
  //   for (let i = 0; i < subDirectories.length; i++) {
  //     const elm = subDirectories[i];
  //     // const subPath = this.state.catego

  //     if (this.state.catego == elm) {
  //       //  alert("doe")
  //       document.getElementById(elm).classList.add('active')
  //     } else {
  //       document.getElementById(elm).classList.remove('active')
  //     }

  //   }

  // }

  responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 8,
      paritialVisibilityGutter: 60
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
      paritialVisibilityGutter: 50
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      paritialVisibilityGutter: 30
    }
  };
  responsiveTemoin = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      paritialVisibilityGutter: 60
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      paritialVisibilityGutter: 50
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 30
    }
  };
  images = [
    "https://images.unsplash.com/photo-1549989476-69a92fa57c36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1549396535-c11d5c55b9df?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1550133730-695473e544be?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1550167164-1b67c2be3973?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1550338861-b7cfeaf8ffd8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1550223640-23097fc71cb2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1550353175-a3611868086b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1550330039-a54e15ed9d33?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1549737328-8b9f3252b927?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1549833284-6a7df91c1f65?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1549985908-597a09ef0a7c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    "https://images.unsplash.com/photo-1550064824-8f993041ffd3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60"
  ];
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }



  render() {
    return (
      <>
        <div className='container landing__cont pb-5 mb-5'>
          {/* <NavTab display="none" under /> */}
          {/* <div className="hero__section container mb-5 d-flex flex-column flex-lg-row justify-content-around align-items-center ">

            <div>
              <h1 className='hero__txt'><span className='hero__big'>Trouvez Votre Bonheur</span><br /><span className='hero__sm'>et organisez votre voyage online</span></h1>
            </div>


            <div className='w-50'>

              <img src="/imgs/home/home_pic.svg" className='hero__logo mb-4 mb-lg-0 d-none d-md-block' alt="" />


            </div>
          </div> */}

          <div id="carouselExampleFade" class="carousel slide carousel-fade d-none d-md-block" data-ride="carousel">
            <div class="carousel-inner " style={{ height: "400px" }}>
              <div class="carousel-item active">
                <img src="/imgs/home/carousel1.svg" className="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item ">
                <img src="/imgs/home/carousel2.svg" className="d-block w-100" alt="..." />
              </div>
              <div class="carousel-item">
                <img src="/imgs/home/carousel3.svg" className="d-block w-100" alt="..." />
              </div>
            </div>
            <button class="carousel-control-prev " type="button" data-target="#carouselExampleFade" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              {/* <span class="sr-only">Previous</span> */}
            </button>
            <button class="carousel-control-next" type="button" data-target="#carouselExampleFade" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              {/* <span class="sr-only">Next</span> */}
            </button>
          </div>

          <NavTabMobile width="150px" page="GHURFATY" />

          <div className="hero__search__tabs container">
            <div className=" ml-3  align-items-center  py-0 px-0 justify-content-start  mb-2 py-0">
              <Row>

                <div className=" col-md-2 col-sm-6 px-0">
                  <UncontrolledDropdown className="w-100" nav inNavbar>
                    <DropdownToggle
                      // id=""
                      className="Advanced-btn-ser px-3 font-weight-bold text-left w-100"
                    >
                      <span className='catego__nameIn'>{this.state.catego}
                      
                      {/* <img  className="px-1"  src={"/imgs/search-Icons/"+ this.state.catego +".svg"} alt="" /> */}
                      </span>

                      <img className="pt-1"
                        src="/imgs/navebar/downArrow.svg"
                        alt="parcouri"
                        id="arrow-parcourir-big"
                      />
                    </DropdownToggle>

                    <DropdownMenu className="catego__select">
                      <DropdownItem value="Hébergements" onMouseDown={(e) => this.setState({ catego: e.target.value })} >Hébergements</DropdownItem>
                      <DropdownItem value="Vols" onMouseDown={(e) => this.setState({ catego: e.target.value })} >Vols</DropdownItem>
                      <DropdownItem value="Visas" onMouseDown={(e) => this.setState({ catego: e.target.value })} >Visas</DropdownItem>
                      <DropdownItem value="Voyages" onMouseDown={(e) => this.setState({ catego: e.target.value })} >Voyages</DropdownItem>
                      <DropdownItem value="Véhicules" onMouseDown={(e) => this.setState({ catego: e.target.value })} >Véhicules</DropdownItem>
                      <DropdownItem value="Divertissements" onMouseDown={(e) => this.setState({ catego: e.target.value })} >Divertissements</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>

                <div className="col-md-10 col-sm-12 px-0">

                  {this.state.catego === "Hébergements" &&
                    <AdvencedSearchGhurfaty />
                  }
                  {this.state.catego === "Vols" &&
                    <AdvancedSearchVols />
                  }
                  {this.state.catego === "Visas" &&
                    <AdvencedSearchVisas />
                  }
                  {this.state.catego === "Voyages" &&
                    <AdvancedSearchVoyage />
                  }
                  {this.state.catego === "Véhicules" &&
                    <div className="mx-3">
                      <AdvancedSearchLocation />
                    </div>
                  }
                </div>

              </Row>


            </div>
            {/* <section className='navigation text-center d-none d-sm-block'>
              <Container>
                <ul className='list-unstyled list-inline border-bottom  border-dark' >
                  <a onClick={(e) => this.setState({ catego: "Hébergements" })} className='text-uppercase '>
                    <li id="Hébergements" className='list-inline-item px-4 py-3' >
                      Hebergements
                    </li>
                  </a>

                  <a onClick={(e) => this.setState({ catego: "Vols" })} className='text-uppercase' >
                    <li id="Vols" className='list-inline-item px-4 py-3'>
                      Vols
                    </li>
                  </a>

                  <a onClick={(e) => this.setState({ catego: "Visas" })} className='text-uppercase '>
                    <li id="Visas" className='list-inline-item px-4 py-3'>
                      Visa
                    </li>
                  </a>

                  <a onClick={(e) => this.setState({ catego: "Voyages" })} className='text-uppercase'>
                    <li id="Voyages" className='list-inline-item px-4 py-3'>
                      voyages
                    </li>
                  </a>
                  <a onClick={(e) => this.setState({ catego: "Véhicules" })} className='text-uppercase'>
                    <li id="Véhicules" className='list-inline-item px-4 py-3'>
                      véhicule
                    </li>
                  </a>

                  <a onClick={(e) => this.setState({ catego: "Divertissements" })} className='text-uppercase'>
                    <li id="divertissements" className='list-inline-item px-4 py-3'>
                      divertissements
                    </li>
                  </a>

                </ul>
                {/* {!this.props.under &&(<hr />)} 

              </Container>
            </section> */}

            <NavTab />


            <div className="home__sponsored d-flex flex-column align-items-center pb-5">
              <span className='home__txt mb-4 sponsored'>Sponsored</span>
              <div className="sponsor__container container mt-2">



                <div>
                  <Carousel responsive={this.responsive} infinite autoPlay>

                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>


                  </Carousel>
                </div>

              </div>

            </div>
            <div className="home__decvr container mt-5 mb-5">
              <h1 className='text-center home__txt decvr__title'>Découvrez Ghurfaty!</h1>
              <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-around mt-4 container">
                <Decvrcard
                  img="/imgs/home/handPhone.svg"
                  title="Facile, et très fiable !"
                  txt="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
                />
                <Decvrcard
                  img="/imgs/home/planePhone.svg"
                  title="Destinations Internationales"
                  txt="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum ..."
                />
                <Decvrcard
                  img="/imgs/home/manPc.svg"
                  title="ALL-IN-ONE Solution"
                  txt="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s..."
                />


              </div>
              <div className="d-flex flex-column flex-md-row justify-content-center mt-4 container ">
                <Decvrcard
                  img="/imgs/home/handChake.svg"
                  title="N°1 pour les Pros"
                  txt="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s..."
                />
                <Decvrcard
                  img="/imgs/home/security.svg"
                  title="Plus sures que jamais!"
                  txt="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s..."
                />



              </div>
            </div>
            <div className="partners">
              <h1 className='text-center home__txt decvr__title mb-5'>Nos Partenaires</h1>
              <div className="sponsor__container container mt-4">



                <div>
                  <Carousel responsive={this.responsive} infinite autoPlay>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                    <div className="card text-left ml-2 mr-2 sponsorCard" >
                      <img
                        className='sponsorCard'
                        src=''
                        alt="Alt text"
                      />
                    </div>
                  </Carousel>
                </div>

              </div>
            </div>
            <div className="temoin mt-5">
              <h1 className='text-center home__txt decvr__title mb-5'>Témoignages</h1>
              <div className="sponsor__container container mt-4">


                {this.state.loading ? (
                  <center>loading...</center>
                ) : (
                  <div>
                    <Carousel responsive={this.responsiveTemoin} infinite autoPlay>
                      <Temoincard img="/imgs/home/temoin.svg" comment="Fabuleux!" name="Youcef Chbel" temoin="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s..." />
                      <Temoincard img="/imgs/home/temoin.svg" comment="Fabuleux!" name="Youcef Chbel" temoin="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s..." />
                      <Temoincard img="/imgs/home/temoin.svg" comment="Fabuleux!" name="Youcef Chbel" temoin="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s..." />
                      <Temoincard img="/imgs/home/temoin.svg" comment="Fabuleux!" name="Youcef Chbel" temoin="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s..." />
                      <Temoincard img="/imgs/home/temoin.svg" comment="Fabuleux!" name="Youcef Chbel" temoin="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s..." />
                      <Temoincard img="/imgs/home/temoin.svg" comment="Fabuleux!" name="Youcef Chbel" temoin="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s..." />

                    </Carousel>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
        {/* <Footer /> */}
      </>
    );
  }
}

export default Home;
